<img class="card"
     role="presentation"
     auto="none"
     [use]="card"
     *ngFor="let card of menu?.licenses" />
<ng-content></ng-content>
